import React from 'react';
import { Button } from 'react-bootstrap';
import './IconButton.css';

const IconButton = ({ icon: Icon, className = '', onClick, disabled = false, ...props }) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={`icon-button d-flex align-items-center justify-content-center ${className}`}
      variant="link"
      {...props}
    >
      {Icon && <Icon className="icon-button-icon" />}
    </Button>
  );
};

export default IconButton;